import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';
import { FaxFileTypeOption } from '../models/fax-file-type-option.interface';

export const faxFileTypeOptionActions = createEagerSelectActions<FaxFileTypeOption>('[Fax File Type Options]');
